export default {
    routes: [
		{
			name: 'userinfo',
			component: () => import('../../view/user/userinfo'),
			meta: {
				title: '个人信息',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			name: 'fzrz',
			component: () => import('../../view/user/fzrz'),
			meta: {
				title: '房屋认证',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			name: 'invoiceHistory',
			path: '/user/invoiceHistory',
			component: () => import('../../view/user/invoiceHistory.vue'),
			meta: {
				title: '开票记录',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			name: 'addhouse',
			component: () => import('../../view/user/addhouse.vue'),
			meta: {
				title: '新增房屋',
				head: false,
				headReturn: true,
				tabbar: false
			}
		},
		{
			name: 'gdyy',
			path: '/user/gdyy',
			component: () => import('../../view/user/gdyy.vue'),
			meta: {
				title: '更多应用',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			name: 'newgdyy',
			path: '/user/newgdyy',
			component: () => import('../../view/user/gdyy_new.vue'),
			meta: {
				title: '更多应用',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			name: 'yjfk',
			component: () => import('../../view/user/yjfk'),
			meta: {
				title: '意见反馈',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			name: 'yjfklist',
			component: () => import('../../view/user/yjfkList'),
			meta: {
				title: '历史反馈记录',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			name: 'yjfkdetail',
			component: () => import('../../view/user/yjfkDetail'),
			meta: {
				title: '反馈详情',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		
		{
			name: 'wxzj',
			component: () => import('../../view/user/wxzj'),
			meta: {
				title: '维修资金',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			name: 'zjcx',
			path: '/user/zjcx',
			component: () => import('../../view/user/zjcx'),
			meta: {
				title: '流水信息',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			name: 'zhcx',
			path: '/user/zhcx',
			component: () => import('../../view/user/zhcx'),
			meta: {
				title: '账户查询',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			name: 'zjjn',
			path: '/user/zjjn',
			component: () => import('../../view/user/zjjn'),
			meta: {
				title: '资金缴纳',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			name: 'zjjn1',
			path: '/user/zjjn1',
			component: () => import('../../view/user/zjjn1'),
			meta: {
				title: '资金缴纳',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			name: 'toupiao',
			path: '/user/toupiao',
			component: () => import('../../view/user/toupiao'),
			meta: {
				title: '投票',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
		{
			name: 'toupiao2',
			path: '/user/toupiao2',
			component: () => import('../../view/user/toupiao'),
			meta: {
				title: '维修金投票',
				head: true,
				headReturn: false,
				tabbar: false
			}
		},
		{
			name: 'jtcy',
			path: '/user/jtcy',
			component: () => import('../../view/user/jtcy'),
			meta: {
				title: '家庭成员',
				head: true,
				headReturn: true,
				tabbar: false
			}
		},
	]
}